import React, { Component } from "react";
import { connect } from "react-redux";
import { ProductSearch } from "../../../redux/actions/Product.Action";
class ProductFilter extends Component {
  render() {
    return (
      <div className="col-12 p-2 card">
        <div className="lookup lookup-md w-100">
          <input
            className="w-100"
            placeholder="Product Search........"
            onFocus={(e) => (e.target.value = "")}
            onChange={(e) => this.props.ProductSearch(e.target.value)}
          />
        </div>
      </div>
    );
  }
}
export default connect(() => ({}), { ProductSearch })(
  React.memo(ProductFilter)
);
